export default "__VITE_ASSET__CUjuBn1F__"